// Keuzes van de 5-staps offertewizard. Waarden komen overeen met de backend (platform_api.ENUMS).
export const STEPS = [
  { title: "Waarmee kunnen wij u helpen?", short: "Product" },
  { title: "Vertel iets over uw woning", short: "Woning" },
  { title: "Wat zijn uw wensen?", short: "Wensen" },
  { title: "Foto's en globale maten", short: "Foto's" },
  { title: "Uw contactgegevens", short: "Contact" },
];

export const PRODUCTS = [
  { id: "kunststof_kozijnen", label: "Kunststof kozijnen" },
  { id: "aluminium_kozijnen", label: "Aluminium kozijnen" },
  { id: "kunststof_schuifpui", label: "Kunststof schuifpui" },
  { id: "aluminium_schuifpui", label: "Aluminium schuifpui" },
  { id: "aluminium_hefschuifpui", label: "Aluminium hefschuifpui" },
  { id: "kunststof_deur", label: "Kunststof deur" },
  { id: "aluminium_deur", label: "Aluminium deur" },
  { id: "meerdere_kozijnen", label: "Meerdere kozijnen / hele woning" },
  { id: "gevelbekleding", label: "Gevelbekleding" },
  { id: "rolluiken", label: "Rolluiken" },
  { id: "velux_dakramen", label: "Velux-dakramen" },
  { id: "anders", label: "Ik weet het nog niet" },
];

// Vragen die per product wel of niet gelden (gevelbekleding en rolluiken hebben geen glas; dakramen geen kleurkeuze).
export const OPERATIONS = [
  { id: "handmatig", label: "Handmatig (band of slinger)" },
  { id: "elektrisch", label: "Elektrisch" },
  { id: "zonne_energie", label: "Op zonne-energie" },
  { id: "advies", label: "Advies gewenst" },
];
export const ROOF_SITUATIONS = [
  { id: "dakraam_vervangen", label: "Bestaand dakraam vervangen" },
  { id: "dakraam_nieuw", label: "Nieuw dakraam plaatsen" },
  { id: "advies", label: "Weet ik nog niet" },
];
const QUANTITY_LABELS = { rolluiken: "Hoeveel rolluiken?", velux_dakramen: "Hoeveel dakramen?" };
export const quantityLabel = (p) => QUANTITY_LABELS[p] || "Hoeveel kozijnen, puien of deuren?";
export const usesQuantity = (p) => p !== "gevelbekleding";
export const usesGlass = (p) => p !== "gevelbekleding" && p !== "rolluiken";
export const usesColor = (p) => p !== "velux_dakramen";

const ONDERWERP_ALIASES = { "kunststof-deuren": "kunststof_deur", "aluminium-deuren": "aluminium_deur", "weet-niet": "anders", "grote-pui": "aluminium_hefschuifpui" };
export const productFromOnderwerp = (slug) => {
  if (!slug) return null;
  const id = ONDERWERP_ALIASES[slug] || slug.replace(/-/g, "_");
  return PRODUCTS.some((p) => p.id === id) ? id : null;
};

export const HOME_TYPES = [
  { id: "tussenwoning", label: "Tussenwoning" },
  { id: "hoekwoning", label: "Hoekwoning" },
  { id: "twee_onder_een_kap", label: "Twee-onder-een-kap" },
  { id: "vrijstaand", label: "Vrijstaand" },
  { id: "appartement", label: "Appartement" },
  { id: "anders", label: "Anders" },
];

export const QUANTITIES = [
  { id: "1", label: "1" },
  { id: "2-3", label: "2 – 3" },
  { id: "4-6", label: "4 – 6" },
  { id: "7+", label: "7 of meer" },
  { id: "onbekend", label: "Weet ik nog niet" },
];

export const COLORS = [
  { id: "Wit", label: "Wit" },
  { id: "Crèmewit", label: "Crèmewit" },
  { id: "Antraciet", label: "Antraciet" },
  { id: "Zwart", label: "Zwart" },
  { id: "Houtlook", label: "Houtlook" },
  { id: "Advies gewenst", label: "Advies gewenst" },
];

export const GLAZING = [
  { id: "hr_plus_plus", label: "HR++ glas" },
  { id: "hr_triple", label: "HR+++ (triple) glas" },
  { id: "advies", label: "Advies gewenst" },
];

export const TIMELINES = [
  { id: "asap", label: "Zo snel mogelijk" },
  { id: "1-3m", label: "Binnen 1 – 3 maanden" },
  { id: "3-6m", label: "Binnen 3 – 6 maanden" },
  { id: "6m+", label: "Over 6 maanden of later" },
  { id: "orienterend", label: "Ik oriënteer me nog" },
];

export const MAX_FILES = 8;
export const MAX_FILE_MB = 10;

export const DOOR_GLASS = [
  { id: "ja", label: "Met glas" },
  { id: "nee", label: "Zonder glas" },
  { id: "advies", label: "Advies gewenst" },
];
export const isDoor = (p) => p === "kunststof_deur" || p === "aluminium_deur";

export const validateContact = (f) => {
  const errors = {};
  if (f.naam.trim().length < 2) errors.naam = "Vul uw naam in";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email.trim())) errors.email = "Vul een geldig e-mailadres in";
  const digits = f.telefoon.replace(/\D/g, "");
  if (!/^[+0-9 ()-]{8,20}$/.test(f.telefoon.trim()) || digits.length < 9 || digits.length > 15)
    errors.telefoon = "Vul een geldig telefoonnummer in";
  return errors;
};

export const postcodeError = (pc) =>
  pc.trim() && !/^\d{4}\s?[A-Za-z]{2}$/.test(pc.trim()) ? "Gebruik het formaat 3142 AB" : "";
